import React, { useContext } from "react";
import { isAdministrator, UserContext } from '../../../context/user';
import { SalesAgencyRow } from '../../SalesAgenciesViewer/SalesAgencyRow/SalesAgencyRow';
import cn from './SalesAgenciesList.module.css';

export function SalesAgenciesList({ data }) {
  const user = useContext(UserContext);

  return (
    <ul className={cn.list}>
      {data.map(agency => (
        <SalesAgencyRow
          key={agency.ID}
          agency={agency}
          showEditIcon={isAdministrator(user)}
          showEmailIcon={false}
        />
      ))}
    </ul>
  );
}
